// export const pub_nub_publishKey = "pub-c-987bb351-8664-464a-88e7-f4945acd43ed"; //prod keys
const userId = localStorage.getItem("userId"); //to set pubnub uuid with respective userid
export const pub_nub_publishKey = "pub-c-9020aa61-fd49-42aa-888e-da5f47448738"; // dev keys
// export const pub_nub_subscribeKey = "sub-c-e1dc87cb-2775-4aa5-b431-08ccc4c8ed9c"; //prod keys
export const pub_nub_subscribeKey =
  "sub-c-e81838e0-9a1a-4c04-9c3f-52f953fc417f"; // dev keys
export const pub_nub_uuid = `us_${userId}`;

//// admin chat channel
export const admin_role_id = 1;
export const support_user_role = 2;

export const pub_nub_publishKey_admin =
  "pub-c-9020aa61-fd49-42aa-888e-da5f47448738";
export const pub_nub_subscribeKey_admin =
  "sub-c-e81838e0-9a1a-4c04-9c3f-52f953fc417f";
export const pub_nub_uuid_admin = "us_admin";
//export const apiUrl = "https://www.test.appointmentapi.utilstop.com/";
export const apiUrl = "https://utilstop.com/";
//export const apiUrl = "http://localhost:3007/";
